import { Tag } from '@/models/tag';

export const extractTagsFrom = (items?: Array<{ lessons: Array<{ tags?: Tag[] }> }>): Tag[] => {
    if (!items || items.length === 0) {
        return [];
    }

    const allTags = items.flatMap((item) => item.lessons.flatMap((lesson) => lesson.tags || []));

    return uniqueTags(allTags);
};

function uniqueTags(allTags: Tag[]) {
    const uniqueTagsMap = new Map<number, typeof allTags[0]>();
    for (const tag of allTags) {
        if (!uniqueTagsMap.has(tag.id)) {
            uniqueTagsMap.set(tag.id, tag);
        }
    }

    return Array.from(uniqueTagsMap.values());
}
